var cov_iirqyzvpw = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Tree/Tree.tsx",
      hash = "1b38f65ebd9fffc9e902a5458d860dd98b718499",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Tree/Tree.tsx",
    statementMap: {
      "0": {
        start: {
          line: 13,
          column: 21
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "1": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 37,
          column: 16
        }
      },
      "2": {
        start: {
          line: 39,
          column: 4
        },
        end: {
          line: 39,
          column: 33
        }
      },
      "3": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 41,
          column: 26
        }
      },
      "4": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 54,
          column: 8
        }
      },
      "5": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 55,
          column: 48
        }
      },
      "6": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 56,
          column: 52
        }
      },
      "7": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 57,
          column: 58
        }
      },
      "8": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 58,
          column: 44
        }
      },
      "9": {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 59,
          column: 48
        }
      },
      "10": {
        start: {
          line: 60,
          column: 4
        },
        end: {
          line: 60,
          column: 83
        }
      },
      "11": {
        start: {
          line: 61,
          column: 4
        },
        end: {
          line: 61,
          column: 74
        }
      },
      "12": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 62,
          column: 67
        }
      },
      "13": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 63,
          column: 20
        }
      },
      "14": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 69,
          column: 5
        }
      },
      "15": {
        start: {
          line: 68,
          column: 6
        },
        end: {
          line: 68,
          column: 46
        }
      },
      "16": {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 72,
          column: 5
        }
      },
      "17": {
        start: {
          line: 71,
          column: 6
        },
        end: {
          line: 71,
          column: 42
        }
      },
      "18": {
        start: {
          line: 74,
          column: 4
        },
        end: {
          line: 78,
          column: 5
        }
      },
      "19": {
        start: {
          line: 75,
          column: 6
        },
        end: {
          line: 75,
          column: 39
        }
      },
      "20": {
        start: {
          line: 76,
          column: 6
        },
        end: {
          line: 76,
          column: 100
        }
      },
      "21": {
        start: {
          line: 76,
          column: 48
        },
        end: {
          line: 76,
          column: 100
        }
      },
      "22": {
        start: {
          line: 77,
          column: 6
        },
        end: {
          line: 77,
          column: 106
        }
      },
      "23": {
        start: {
          line: 77,
          column: 71
        },
        end: {
          line: 77,
          column: 106
        }
      },
      "24": {
        start: {
          line: 82,
          column: 23
        },
        end: {
          line: 82,
          column: 33
        }
      },
      "25": {
        start: {
          line: 83,
          column: 4
        },
        end: {
          line: 83,
          column: 60
        }
      },
      "26": {
        start: {
          line: 87,
          column: 26
        },
        end: {
          line: 87,
          column: 36
        }
      },
      "27": {
        start: {
          line: 88,
          column: 4
        },
        end: {
          line: 88,
          column: 40
        }
      },
      "28": {
        start: {
          line: 88,
          column: 19
        },
        end: {
          line: 88,
          column: 40
        }
      },
      "29": {
        start: {
          line: 98,
          column: 4
        },
        end: {
          line: 98,
          column: 30
        }
      },
      "30": {
        start: {
          line: 100,
          column: 19
        },
        end: {
          line: 100,
          column: 43
        }
      },
      "31": {
        start: {
          line: 101,
          column: 21
        },
        end: {
          line: 101,
          column: 70
        }
      },
      "32": {
        start: {
          line: 102,
          column: 4
        },
        end: {
          line: 104,
          column: 5
        }
      },
      "33": {
        start: {
          line: 103,
          column: 6
        },
        end: {
          line: 103,
          column: 39
        }
      },
      "34": {
        start: {
          line: 106,
          column: 4
        },
        end: {
          line: 106,
          column: 74
        }
      },
      "35": {
        start: {
          line: 110,
          column: 4
        },
        end: {
          line: 110,
          column: 25
        }
      },
      "36": {
        start: {
          line: 114,
          column: 17
        },
        end: {
          line: 114,
          column: 34
        }
      },
      "37": {
        start: {
          line: 115,
          column: 4
        },
        end: {
          line: 117,
          column: 5
        }
      },
      "38": {
        start: {
          line: 116,
          column: 6
        },
        end: {
          line: 116,
          column: 38
        }
      },
      "39": {
        start: {
          line: 121,
          column: 4
        },
        end: {
          line: 123,
          column: 5
        }
      },
      "40": {
        start: {
          line: 122,
          column: 6
        },
        end: {
          line: 122,
          column: 37
        }
      },
      "41": {
        start: {
          line: 127,
          column: 32
        },
        end: {
          line: 127,
          column: 42
        }
      },
      "42": {
        start: {
          line: 128,
          column: 4
        },
        end: {
          line: 132,
          column: 5
        }
      },
      "43": {
        start: {
          line: 129,
          column: 6
        },
        end: {
          line: 131,
          column: 8
        }
      },
      "44": {
        start: {
          line: 130,
          column: 8
        },
        end: {
          line: 130,
          column: 29
        }
      },
      "45": {
        start: {
          line: 133,
          column: 4
        },
        end: {
          line: 135,
          column: 5
        }
      },
      "46": {
        start: {
          line: 134,
          column: 6
        },
        end: {
          line: 134,
          column: 48
        }
      },
      "47": {
        start: {
          line: 139,
          column: 35
        },
        end: {
          line: 139,
          column: 45
        }
      },
      "48": {
        start: {
          line: 142,
          column: 4
        },
        end: {
          line: 145,
          column: 5
        }
      },
      "49": {
        start: {
          line: 143,
          column: 6
        },
        end: {
          line: 143,
          column: 20
        }
      },
      "50": {
        start: {
          line: 144,
          column: 6
        },
        end: {
          line: 144,
          column: 12
        }
      },
      "51": {
        start: {
          line: 146,
          column: 24
        },
        end: {
          line: 146,
          column: 33
        }
      },
      "52": {
        start: {
          line: 147,
          column: 4
        },
        end: {
          line: 151,
          column: 5
        }
      },
      "53": {
        start: {
          line: 148,
          column: 6
        },
        end: {
          line: 148,
          column: 53
        }
      },
      "54": {
        start: {
          line: 148,
          column: 44
        },
        end: {
          line: 148,
          column: 52
        }
      },
      "55": {
        start: {
          line: 150,
          column: 6
        },
        end: {
          line: 150,
          column: 40
        }
      },
      "56": {
        start: {
          line: 152,
          column: 4
        },
        end: {
          line: 152,
          column: 39
        }
      },
      "57": {
        start: {
          line: 152,
          column: 18
        },
        end: {
          line: 152,
          column: 39
        }
      },
      "58": {
        start: {
          line: 156,
          column: 28
        },
        end: {
          line: 156,
          column: 38
        }
      },
      "59": {
        start: {
          line: 157,
          column: 20
        },
        end: {
          line: 157,
          column: 42
        }
      },
      "60": {
        start: {
          line: 158,
          column: 19
        },
        end: {
          line: 158,
          column: 47
        }
      },
      "61": {
        start: {
          line: 159,
          column: 4
        },
        end: {
          line: 159,
          column: 35
        }
      },
      "62": {
        start: {
          line: 159,
          column: 29
        },
        end: {
          line: 159,
          column: 35
        }
      },
      "63": {
        start: {
          line: 160,
          column: 17
        },
        end: {
          line: 202,
          column: 6
        }
      },
      "64": {
        start: {
          line: 161,
          column: 22
        },
        end: {
          line: 161,
          column: 27
        }
      },
      "65": {
        start: {
          line: 163,
          column: 35
        },
        end: {
          line: 163,
          column: 43
        }
      },
      "66": {
        start: {
          line: 164,
          column: 19
        },
        end: {
          line: 164,
          column: 20
        }
      },
      "67": {
        start: {
          line: 165,
          column: 6
        },
        end: {
          line: 173,
          column: 8
        }
      },
      "68": {
        start: {
          line: 166,
          column: 8
        },
        end: {
          line: 172,
          column: 9
        }
      },
      "69": {
        start: {
          line: 167,
          column: 10
        },
        end: {
          line: 167,
          column: 51
        }
      },
      "70": {
        start: {
          line: 169,
          column: 10
        },
        end: {
          line: 169,
          column: 21
        }
      },
      "71": {
        start: {
          line: 170,
          column: 10
        },
        end: {
          line: 170,
          column: 49
        }
      },
      "72": {
        start: {
          line: 170,
          column: 29
        },
        end: {
          line: 170,
          column: 49
        }
      },
      "73": {
        start: {
          line: 171,
          column: 10
        },
        end: {
          line: 171,
          column: 24
        }
      },
      "74": {
        start: {
          line: 175,
          column: 23
        },
        end: {
          line: 175,
          column: 28
        }
      },
      "75": {
        start: {
          line: 176,
          column: 6
        },
        end: {
          line: 187,
          column: 8
        }
      },
      "76": {
        start: {
          line: 177,
          column: 8
        },
        end: {
          line: 186,
          column: 9
        }
      },
      "77": {
        start: {
          line: 178,
          column: 10
        },
        end: {
          line: 178,
          column: 39
        }
      },
      "78": {
        start: {
          line: 179,
          column: 15
        },
        end: {
          line: 186,
          column: 9
        }
      },
      "79": {
        start: {
          line: 181,
          column: 10
        },
        end: {
          line: 181,
          column: 22
        }
      },
      "80": {
        start: {
          line: 182,
          column: 10
        },
        end: {
          line: 184,
          column: 11
        }
      },
      "81": {
        start: {
          line: 183,
          column: 12
        },
        end: {
          line: 183,
          column: 23
        }
      },
      "82": {
        start: {
          line: 185,
          column: 10
        },
        end: {
          line: 185,
          column: 31
        }
      },
      "83": {
        start: {
          line: 189,
          column: 6
        },
        end: {
          line: 199,
          column: 7
        }
      },
      "84": {
        start: {
          line: 190,
          column: 8
        },
        end: {
          line: 190,
          column: 44
        }
      },
      "85": {
        start: {
          line: 191,
          column: 8
        },
        end: {
          line: 191,
          column: 71
        }
      },
      "86": {
        start: {
          line: 191,
          column: 48
        },
        end: {
          line: 191,
          column: 71
        }
      },
      "87": {
        start: {
          line: 192,
          column: 8
        },
        end: {
          line: 192,
          column: 37
        }
      },
      "88": {
        start: {
          line: 193,
          column: 8
        },
        end: {
          line: 193,
          column: 48
        }
      },
      "89": {
        start: {
          line: 194,
          column: 23
        },
        end: {
          line: 194,
          column: 47
        }
      },
      "90": {
        start: {
          line: 195,
          column: 8
        },
        end: {
          line: 195,
          column: 44
        }
      },
      "91": {
        start: {
          line: 195,
          column: 20
        },
        end: {
          line: 195,
          column: 44
        }
      },
      "92": {
        start: {
          line: 197,
          column: 8
        },
        end: {
          line: 197,
          column: 48
        }
      },
      "93": {
        start: {
          line: 198,
          column: 8
        },
        end: {
          line: 198,
          column: 54
        }
      },
      "94": {
        start: {
          line: 201,
          column: 6
        },
        end: {
          line: 201,
          column: 18
        }
      },
      "95": {
        start: {
          line: 203,
          column: 4
        },
        end: {
          line: 205,
          column: 5
        }
      },
      "96": {
        start: {
          line: 204,
          column: 6
        },
        end: {
          line: 204,
          column: 53
        }
      },
      "97": {
        start: {
          line: 209,
          column: 4
        },
        end: {
          line: 209,
          column: 26
        }
      },
      "98": {
        start: {
          line: 238,
          column: 8
        },
        end: {
          line: 238,
          column: 18
        }
      },
      "99": {
        start: {
          line: 239,
          column: 21
        },
        end: {
          line: 239,
          column: 61
        }
      },
      "100": {
        start: {
          line: 241,
          column: 4
        },
        end: {
          line: 272,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 36,
            column: 3
          }
        },
        loc: {
          start: {
            line: 36,
            column: 49
          },
          end: {
            line: 64,
            column: 3
          }
        },
        line: 36
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 66,
            column: 2
          },
          end: {
            line: 66,
            column: 3
          }
        },
        loc: {
          start: {
            line: 66,
            column: 60
          },
          end: {
            line: 79,
            column: 3
          }
        },
        line: 66
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 81,
            column: 2
          },
          end: {
            line: 81,
            column: 3
          }
        },
        loc: {
          start: {
            line: 81,
            column: 14
          },
          end: {
            line: 84,
            column: 3
          }
        },
        line: 81
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 86,
            column: 2
          },
          end: {
            line: 86,
            column: 3
          }
        },
        loc: {
          start: {
            line: 86,
            column: 14
          },
          end: {
            line: 89,
            column: 3
          }
        },
        line: 86
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 91,
            column: 2
          },
          end: {
            line: 91,
            column: 3
          }
        },
        loc: {
          start: {
            line: 91,
            column: 49
          },
          end: {
            line: 107,
            column: 3
          }
        },
        line: 91
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 109,
            column: 2
          },
          end: {
            line: 109,
            column: 3
          }
        },
        loc: {
          start: {
            line: 109,
            column: 31
          },
          end: {
            line: 111,
            column: 3
          }
        },
        line: 109
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 113,
            column: 2
          },
          end: {
            line: 113,
            column: 3
          }
        },
        loc: {
          start: {
            line: 113,
            column: 44
          },
          end: {
            line: 118,
            column: 3
          }
        },
        line: 113
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 120,
            column: 2
          },
          end: {
            line: 120,
            column: 3
          }
        },
        loc: {
          start: {
            line: 120,
            column: 38
          },
          end: {
            line: 124,
            column: 3
          }
        },
        line: 120
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 126,
            column: 2
          },
          end: {
            line: 126,
            column: 3
          }
        },
        loc: {
          start: {
            line: 126,
            column: 52
          },
          end: {
            line: 136,
            column: 3
          }
        },
        line: 126
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 129,
            column: 36
          },
          end: {
            line: 129,
            column: 37
          }
        },
        loc: {
          start: {
            line: 129,
            column: 42
          },
          end: {
            line: 131,
            column: 7
          }
        },
        line: 129
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 138,
            column: 2
          },
          end: {
            line: 138,
            column: 3
          }
        },
        loc: {
          start: {
            line: 138,
            column: 33
          },
          end: {
            line: 153,
            column: 3
          }
        },
        line: 138
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 148,
            column: 39
          },
          end: {
            line: 148,
            column: 40
          }
        },
        loc: {
          start: {
            line: 148,
            column: 44
          },
          end: {
            line: 148,
            column: 52
          }
        },
        line: 148
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 155,
            column: 2
          },
          end: {
            line: 155,
            column: 3
          }
        },
        loc: {
          start: {
            line: 155,
            column: 73
          },
          end: {
            line: 206,
            column: 3
          }
        },
        line: 155
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 160,
            column: 41
          },
          end: {
            line: 160,
            column: 42
          }
        },
        loc: {
          start: {
            line: 160,
            column: 50
          },
          end: {
            line: 202,
            column: 5
          }
        },
        line: 160
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 163,
            column: 35
          },
          end: {
            line: 163,
            column: 36
          }
        },
        loc: {
          start: {
            line: 163,
            column: 41
          },
          end: {
            line: 163,
            column: 43
          }
        },
        line: 163
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 165,
            column: 32
          },
          end: {
            line: 165,
            column: 33
          }
        },
        loc: {
          start: {
            line: 165,
            column: 42
          },
          end: {
            line: 173,
            column: 7
          }
        },
        line: 165
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 170,
            column: 23
          },
          end: {
            line: 170,
            column: 24
          }
        },
        loc: {
          start: {
            line: 170,
            column: 29
          },
          end: {
            line: 170,
            column: 49
          }
        },
        line: 170
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 176,
            column: 31
          },
          end: {
            line: 176,
            column: 32
          }
        },
        loc: {
          start: {
            line: 176,
            column: 41
          },
          end: {
            line: 187,
            column: 7
          }
        },
        line: 176
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 185,
            column: 23
          },
          end: {
            line: 185,
            column: 24
          }
        },
        loc: {
          start: {
            line: 185,
            column: 29
          },
          end: {
            line: 185,
            column: 31
          }
        },
        line: 185
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 208,
            column: 2
          },
          end: {
            line: 208,
            column: 3
          }
        },
        loc: {
          start: {
            line: 208,
            column: 72
          },
          end: {
            line: 210,
            column: 3
          }
        },
        line: 208
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 212,
            column: 2
          },
          end: {
            line: 212,
            column: 3
          }
        },
        loc: {
          start: {
            line: 212,
            column: 11
          },
          end: {
            line: 273,
            column: 3
          }
        },
        line: 212
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 43,
            column: 6
          },
          end: {
            line: 54,
            column: 8
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 43,
            column: 6
          },
          end: {
            line: 43,
            column: 17
          }
        }, {
          start: {
            line: 44,
            column: 6
          },
          end: {
            line: 54,
            column: 8
          }
        }],
        line: 43
      },
      "1": {
        loc: {
          start: {
            line: 50,
            column: 15
          },
          end: {
            line: 50,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 50,
            column: 15
          },
          end: {
            line: 50,
            column: 26
          }
        }, {
          start: {
            line: 50,
            column: 30
          },
          end: {
            line: 50,
            column: 48
          }
        }],
        line: 50
      },
      "2": {
        loc: {
          start: {
            line: 51,
            column: 18
          },
          end: {
            line: 51,
            column: 83
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 51,
            column: 57
          },
          end: {
            line: 51,
            column: 71
          }
        }, {
          start: {
            line: 51,
            column: 74
          },
          end: {
            line: 51,
            column: 83
          }
        }],
        line: 51
      },
      "3": {
        loc: {
          start: {
            line: 52,
            column: 21
          },
          end: {
            line: 52,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 52,
            column: 21
          },
          end: {
            line: 52,
            column: 38
          }
        }, {
          start: {
            line: 52,
            column: 42
          },
          end: {
            line: 52,
            column: 66
          }
        }],
        line: 52
      },
      "4": {
        loc: {
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 69,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 69,
            column: 5
          }
        }, {
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 69,
            column: 5
          }
        }],
        line: 67
      },
      "5": {
        loc: {
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 72,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 72,
            column: 5
          }
        }, {
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 72,
            column: 5
          }
        }],
        line: 70
      },
      "6": {
        loc: {
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 78,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 78,
            column: 5
          }
        }, {
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 78,
            column: 5
          }
        }],
        line: 74
      },
      "7": {
        loc: {
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 74,
            column: 74
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 74,
            column: 27
          }
        }, {
          start: {
            line: 74,
            column: 31
          },
          end: {
            line: 74,
            column: 48
          }
        }, {
          start: {
            line: 74,
            column: 52
          },
          end: {
            line: 74,
            column: 74
          }
        }],
        line: 74
      },
      "8": {
        loc: {
          start: {
            line: 76,
            column: 6
          },
          end: {
            line: 76,
            column: 100
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 76,
            column: 6
          },
          end: {
            line: 76,
            column: 100
          }
        }, {
          start: {
            line: 76,
            column: 6
          },
          end: {
            line: 76,
            column: 100
          }
        }],
        line: 76
      },
      "9": {
        loc: {
          start: {
            line: 76,
            column: 68
          },
          end: {
            line: 76,
            column: 99
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 76,
            column: 68
          },
          end: {
            line: 76,
            column: 84
          }
        }, {
          start: {
            line: 76,
            column: 89
          },
          end: {
            line: 76,
            column: 98
          }
        }],
        line: 76
      },
      "10": {
        loc: {
          start: {
            line: 77,
            column: 6
          },
          end: {
            line: 77,
            column: 106
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 77,
            column: 6
          },
          end: {
            line: 77,
            column: 106
          }
        }, {
          start: {
            line: 77,
            column: 6
          },
          end: {
            line: 77,
            column: 106
          }
        }],
        line: 77
      },
      "11": {
        loc: {
          start: {
            line: 77,
            column: 10
          },
          end: {
            line: 77,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 77,
            column: 10
          },
          end: {
            line: 77,
            column: 44
          }
        }, {
          start: {
            line: 77,
            column: 48
          },
          end: {
            line: 77,
            column: 69
          }
        }],
        line: 77
      },
      "12": {
        loc: {
          start: {
            line: 83,
            column: 11
          },
          end: {
            line: 83,
            column: 60
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 83,
            column: 34
          },
          end: {
            line: 83,
            column: 51
          }
        }, {
          start: {
            line: 83,
            column: 54
          },
          end: {
            line: 83,
            column: 60
          }
        }],
        line: 83
      },
      "13": {
        loc: {
          start: {
            line: 88,
            column: 4
          },
          end: {
            line: 88,
            column: 40
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 88,
            column: 4
          },
          end: {
            line: 88,
            column: 40
          }
        }, {
          start: {
            line: 88,
            column: 4
          },
          end: {
            line: 88,
            column: 40
          }
        }],
        line: 88
      },
      "14": {
        loc: {
          start: {
            line: 101,
            column: 21
          },
          end: {
            line: 101,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 101,
            column: 21
          },
          end: {
            line: 101,
            column: 40
          }
        }, {
          start: {
            line: 101,
            column: 44
          },
          end: {
            line: 101,
            column: 70
          }
        }],
        line: 101
      },
      "15": {
        loc: {
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 104,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 104,
            column: 5
          }
        }, {
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 104,
            column: 5
          }
        }],
        line: 102
      },
      "16": {
        loc: {
          start: {
            line: 106,
            column: 34
          },
          end: {
            line: 106,
            column: 71
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 106,
            column: 34
          },
          end: {
            line: 106,
            column: 42
          }
        }, {
          start: {
            line: 106,
            column: 46
          },
          end: {
            line: 106,
            column: 71
          }
        }],
        line: 106
      },
      "17": {
        loc: {
          start: {
            line: 128,
            column: 4
          },
          end: {
            line: 132,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 128,
            column: 4
          },
          end: {
            line: 132,
            column: 5
          }
        }, {
          start: {
            line: 128,
            column: 4
          },
          end: {
            line: 132,
            column: 5
          }
        }],
        line: 128
      },
      "18": {
        loc: {
          start: {
            line: 133,
            column: 4
          },
          end: {
            line: 135,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 133,
            column: 4
          },
          end: {
            line: 135,
            column: 5
          }
        }, {
          start: {
            line: 133,
            column: 4
          },
          end: {
            line: 135,
            column: 5
          }
        }],
        line: 133
      },
      "19": {
        loc: {
          start: {
            line: 142,
            column: 4
          },
          end: {
            line: 145,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 142,
            column: 4
          },
          end: {
            line: 145,
            column: 5
          }
        }, {
          start: {
            line: 142,
            column: 4
          },
          end: {
            line: 145,
            column: 5
          }
        }],
        line: 142
      },
      "20": {
        loc: {
          start: {
            line: 142,
            column: 8
          },
          end: {
            line: 142,
            column: 29
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 142,
            column: 8
          },
          end: {
            line: 142,
            column: 17
          }
        }, {
          start: {
            line: 142,
            column: 21
          },
          end: {
            line: 142,
            column: 29
          }
        }],
        line: 142
      },
      "21": {
        loc: {
          start: {
            line: 147,
            column: 4
          },
          end: {
            line: 151,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 147,
            column: 4
          },
          end: {
            line: 151,
            column: 5
          }
        }, {
          start: {
            line: 147,
            column: 4
          },
          end: {
            line: 151,
            column: 5
          }
        }],
        line: 147
      },
      "22": {
        loc: {
          start: {
            line: 152,
            column: 4
          },
          end: {
            line: 152,
            column: 39
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 152,
            column: 4
          },
          end: {
            line: 152,
            column: 39
          }
        }, {
          start: {
            line: 152,
            column: 4
          },
          end: {
            line: 152,
            column: 39
          }
        }],
        line: 152
      },
      "23": {
        loc: {
          start: {
            line: 159,
            column: 4
          },
          end: {
            line: 159,
            column: 35
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 159,
            column: 4
          },
          end: {
            line: 159,
            column: 35
          }
        }, {
          start: {
            line: 159,
            column: 4
          },
          end: {
            line: 159,
            column: 35
          }
        }],
        line: 159
      },
      "24": {
        loc: {
          start: {
            line: 159,
            column: 8
          },
          end: {
            line: 159,
            column: 27
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 159,
            column: 8
          },
          end: {
            line: 159,
            column: 16
          }
        }, {
          start: {
            line: 159,
            column: 20
          },
          end: {
            line: 159,
            column: 27
          }
        }],
        line: 159
      },
      "25": {
        loc: {
          start: {
            line: 166,
            column: 8
          },
          end: {
            line: 172,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 166,
            column: 8
          },
          end: {
            line: 172,
            column: 9
          }
        }, {
          start: {
            line: 166,
            column: 8
          },
          end: {
            line: 172,
            column: 9
          }
        }],
        line: 166
      },
      "26": {
        loc: {
          start: {
            line: 177,
            column: 8
          },
          end: {
            line: 186,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 177,
            column: 8
          },
          end: {
            line: 186,
            column: 9
          }
        }, {
          start: {
            line: 177,
            column: 8
          },
          end: {
            line: 186,
            column: 9
          }
        }],
        line: 177
      },
      "27": {
        loc: {
          start: {
            line: 179,
            column: 15
          },
          end: {
            line: 186,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 179,
            column: 15
          },
          end: {
            line: 186,
            column: 9
          }
        }, {
          start: {
            line: 179,
            column: 15
          },
          end: {
            line: 186,
            column: 9
          }
        }],
        line: 179
      },
      "28": {
        loc: {
          start: {
            line: 182,
            column: 10
          },
          end: {
            line: 184,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 182,
            column: 10
          },
          end: {
            line: 184,
            column: 11
          }
        }, {
          start: {
            line: 182,
            column: 10
          },
          end: {
            line: 184,
            column: 11
          }
        }],
        line: 182
      },
      "29": {
        loc: {
          start: {
            line: 189,
            column: 6
          },
          end: {
            line: 199,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 189,
            column: 6
          },
          end: {
            line: 199,
            column: 7
          }
        }, {
          start: {
            line: 189,
            column: 6
          },
          end: {
            line: 199,
            column: 7
          }
        }],
        line: 189
      },
      "30": {
        loc: {
          start: {
            line: 191,
            column: 8
          },
          end: {
            line: 191,
            column: 71
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 191,
            column: 8
          },
          end: {
            line: 191,
            column: 71
          }
        }, {
          start: {
            line: 191,
            column: 8
          },
          end: {
            line: 191,
            column: 71
          }
        }],
        line: 191
      },
      "31": {
        loc: {
          start: {
            line: 195,
            column: 8
          },
          end: {
            line: 195,
            column: 44
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 195,
            column: 8
          },
          end: {
            line: 195,
            column: 44
          }
        }, {
          start: {
            line: 195,
            column: 8
          },
          end: {
            line: 195,
            column: 44
          }
        }],
        line: 195
      },
      "32": {
        loc: {
          start: {
            line: 203,
            column: 4
          },
          end: {
            line: 205,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 203,
            column: 4
          },
          end: {
            line: 205,
            column: 5
          }
        }, {
          start: {
            line: 203,
            column: 4
          },
          end: {
            line: 205,
            column: 5
          }
        }],
        line: 203
      },
      "33": {
        loc: {
          start: {
            line: 223,
            column: 6
          },
          end: {
            line: 223,
            column: 30
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 223,
            column: 13
          },
          end: {
            line: 223,
            column: 30
          }
        }],
        line: 223
      },
      "34": {
        loc: {
          start: {
            line: 229,
            column: 6
          },
          end: {
            line: 229,
            column: 50
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 229,
            column: 23
          },
          end: {
            line: 229,
            column: 50
          }
        }],
        line: 229
      },
      "35": {
        loc: {
          start: {
            line: 239,
            column: 21
          },
          end: {
            line: 239,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 239,
            column: 32
          },
          end: {
            line: 239,
            column: 49
          }
        }, {
          start: {
            line: 239,
            column: 52
          },
          end: {
            line: 239,
            column: 61
          }
        }],
        line: 239
      },
      "36": {
        loc: {
          start: {
            line: 246,
            column: 18
          },
          end: {
            line: 246,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 246,
            column: 18
          },
          end: {
            line: 246,
            column: 48
          }
        }, {
          start: {
            line: 246,
            column: 52
          },
          end: {
            line: 246,
            column: 62
          }
        }],
        line: 246
      },
      "37": {
        loc: {
          start: {
            line: 254,
            column: 16
          },
          end: {
            line: 254,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 254,
            column: 16
          },
          end: {
            line: 254,
            column: 22
          }
        }, {
          start: {
            line: 254,
            column: 26
          },
          end: {
            line: 254,
            column: 41
          }
        }],
        line: 254
      },
      "38": {
        loc: {
          start: {
            line: 263,
            column: 27
          },
          end: {
            line: 263,
            column: 117
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 263,
            column: 69
          },
          end: {
            line: 263,
            column: 86
          }
        }, {
          start: {
            line: 263,
            column: 89
          },
          end: {
            line: 263,
            column: 117
          }
        }],
        line: 263
      },
      "39": {
        loc: {
          start: {
            line: 264,
            column: 23
          },
          end: {
            line: 264,
            column: 100
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 264,
            column: 61
          },
          end: {
            line: 264,
            column: 74
          }
        }, {
          start: {
            line: 264,
            column: 77
          },
          end: {
            line: 264,
            column: 100
          }
        }],
        line: 264
      },
      "40": {
        loc: {
          start: {
            line: 265,
            column: 19
          },
          end: {
            line: 265,
            column: 85
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 265,
            column: 53
          },
          end: {
            line: 265,
            column: 62
          }
        }, {
          start: {
            line: 265,
            column: 65
          },
          end: {
            line: 265,
            column: 85
          }
        }],
        line: 265
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0],
      "34": [0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _toConsumableArray from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Tree/Tree.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import immer from 'immer';
import { PureComponent } from '../component';
import DatumTree from '../Datum/Tree';
import Root from './Root';
var DefaultProps = (cov_iirqyzvpw.s[0]++, {
  data: [],
  defaultExpanded: [],
  defaultValue: [],
  mode: 0,
  dataUpdate: true,
  childrenKey: 'children',
  dragImageStyle: {}
});

var Tree =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Tree, _PureComponent);

  var _super = _createSuper2(Tree);

  function Tree(props) {
    var _this;

    _classCallCheck(this, Tree);

    cov_iirqyzvpw.f[0]++;
    cov_iirqyzvpw.s[1]++;
    _this = _super.call(this, props);
    _this.handleDragImageSelector = void 0;
    _this.handleClidrenClass = void 0;
    _this.handleLeafClass = void 0;
    _this.nodes = void 0;
    _this.datum = void 0;
    cov_iirqyzvpw.s[2]++;
    _this.state = {
      active: null
    };
    cov_iirqyzvpw.s[3]++;
    _this.nodes = new Map();
    cov_iirqyzvpw.s[4]++;
    _this.datum = (cov_iirqyzvpw.b[0][0]++, props.datum) || (cov_iirqyzvpw.b[0][1]++, new DatumTree({
      data: props.data,
      loader: props.loader,
      keygen: props.keygen,
      mode: props.mode,
      onChange: props.onChange,
      value: (cov_iirqyzvpw.b[1][0]++, props.value) || (cov_iirqyzvpw.b[1][1]++, props.defaultValue),
      disabled: typeof props.disabled === 'function' ? (cov_iirqyzvpw.b[2][0]++, props.disabled) : (cov_iirqyzvpw.b[2][1]++, undefined),
      childrenKey: (cov_iirqyzvpw.b[3][0]++, props.childrenKey) || (cov_iirqyzvpw.b[3][1]++, DefaultProps.childrenKey),
      unmatch: props.unmatch
    }));
    cov_iirqyzvpw.s[5]++;
    _this.handleDrop = _this.handleDrop.bind(_assertThisInitialized(_this));
    cov_iirqyzvpw.s[6]++;
    _this.handleToggle = _this.handleToggle.bind(_assertThisInitialized(_this));
    cov_iirqyzvpw.s[7]++;
    _this.handleNodeClick = _this.handleNodeClick.bind(_assertThisInitialized(_this));
    cov_iirqyzvpw.s[8]++;
    _this.bindNode = _this.bindNode.bind(_assertThisInitialized(_this));
    cov_iirqyzvpw.s[9]++;
    _this.unbindNode = _this.unbindNode.bind(_assertThisInitialized(_this));
    cov_iirqyzvpw.s[10]++;
    _this.handleDragImageSelector = _this.handleProps.bind(_assertThisInitialized(_this), 'dragImageSelector');
    cov_iirqyzvpw.s[11]++;
    _this.handleClidrenClass = _this.handleProps.bind(_assertThisInitialized(_this), 'childrenClass');
    cov_iirqyzvpw.s[12]++;
    _this.handleLeafClass = _this.handleProps.bind(_assertThisInitialized(_this), 'leafClass');
    cov_iirqyzvpw.s[13]++;

    _this.bindDatum();

    return _this;
  }

  _createClass(Tree, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      cov_iirqyzvpw.f[1]++;
      cov_iirqyzvpw.s[14]++;

      if (prevProps.expanded !== this.props.expanded) {
        cov_iirqyzvpw.b[4][0]++;
        cov_iirqyzvpw.s[15]++;
        this.handleExpanded(this.props.expanded);
      } else {
        cov_iirqyzvpw.b[4][1]++;
      }

      cov_iirqyzvpw.s[16]++;

      if (prevProps.active !== this.props.active) {
        cov_iirqyzvpw.b[5][0]++;
        cov_iirqyzvpw.s[17]++;
        this.handleActive(this.props.active);
      } else {
        cov_iirqyzvpw.b[5][1]++;
      }

      cov_iirqyzvpw.s[18]++;

      if ((cov_iirqyzvpw.b[7][0]++, this.props.onChange) || (cov_iirqyzvpw.b[7][1]++, this.props.onDrop) || (cov_iirqyzvpw.b[7][2]++, this.props.radioUpdate)) {
        cov_iirqyzvpw.b[6][0]++;
        cov_iirqyzvpw.s[19]++;
        this.datum.mode = this.props.mode;
        cov_iirqyzvpw.s[20]++;

        if (prevProps.value !== this.props.value) {
          cov_iirqyzvpw.b[8][0]++;
          cov_iirqyzvpw.s[21]++;
          this.datum.setValue((cov_iirqyzvpw.b[9][0]++, this.props.value) || (cov_iirqyzvpw.b[9][1]++, []));
        } else {
          cov_iirqyzvpw.b[8][1]++;
        }

        cov_iirqyzvpw.s[22]++;

        if ((cov_iirqyzvpw.b[11][0]++, prevProps.data !== this.props.data) && (cov_iirqyzvpw.b[11][1]++, this.props.dataUpdate)) {
          cov_iirqyzvpw.b[10][0]++;
          cov_iirqyzvpw.s[23]++;
          this.datum.setData(this.props.data);
        } else {
          cov_iirqyzvpw.b[10][1]++;
        }
      } else {
        cov_iirqyzvpw.b[6][1]++;
      }
    }
  }, {
    key: "getActive",
    value: function getActive() {
      cov_iirqyzvpw.f[2]++;

      var _ref = (cov_iirqyzvpw.s[24]++, this.props),
          active = _ref.active;

      cov_iirqyzvpw.s[25]++;
      return active === undefined ? (cov_iirqyzvpw.b[12][0]++, this.state.active) : (cov_iirqyzvpw.b[12][1]++, active);
    }
  }, {
    key: "bindDatum",
    value: function bindDatum() {
      cov_iirqyzvpw.f[3]++;

      var _ref2 = (cov_iirqyzvpw.s[26]++, this.props),
          bindDatum = _ref2.bindDatum;

      cov_iirqyzvpw.s[27]++;

      if (bindDatum) {
        cov_iirqyzvpw.b[13][0]++;
        cov_iirqyzvpw.s[28]++;
        bindDatum(this.datum);
      } else {
        cov_iirqyzvpw.b[13][1]++;
      }
    }
  }, {
    key: "bindNode",
    value: function bindNode(id, update) {
      cov_iirqyzvpw.f[4]++;
      cov_iirqyzvpw.s[29]++;

      /*
      if (this.nodes.has(id)) {
        console.error(`Node with '${id}' key has already been added. Tree node's key must be unique.`)
        return {}
      }
      */
      this.nodes.set(id, update);
      var active = (cov_iirqyzvpw.s[30]++, this.props.active === id);
      var expanded = (cov_iirqyzvpw.s[31]++, (cov_iirqyzvpw.b[14][0]++, this.props.expanded) || (cov_iirqyzvpw.b[14][1]++, this.props.defaultExpanded));
      cov_iirqyzvpw.s[32]++;

      if (this.props.defaultExpandAll) {
        cov_iirqyzvpw.b[15][0]++;
        cov_iirqyzvpw.s[33]++;
        return {
          active: active,
          expanded: true
        };
      } else {
        cov_iirqyzvpw.b[15][1]++;
      }

      cov_iirqyzvpw.s[34]++;
      return {
        active: active,
        expanded: !!((cov_iirqyzvpw.b[16][0]++, expanded) && (cov_iirqyzvpw.b[16][1]++, expanded.indexOf(id) >= 0))
      };
    }
  }, {
    key: "unbindNode",
    value: function unbindNode(id) {
      cov_iirqyzvpw.f[5]++;
      cov_iirqyzvpw.s[35]++;
      this.nodes["delete"](id);
    }
  }, {
    key: "handleExpanded",
    value: function handleExpanded(expanded) {
      cov_iirqyzvpw.f[6]++;
      var temp = (cov_iirqyzvpw.s[36]++, new Set(expanded));
      cov_iirqyzvpw.s[37]++;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = _slicedToArray(_step.value, 2),
              id = _step$value[0],
              update = _step$value[1];

          cov_iirqyzvpw.s[38]++;
          update('expanded', temp.has(id));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "handleActive",
    value: function handleActive(active) {
      cov_iirqyzvpw.f[7]++;
      cov_iirqyzvpw.s[39]++;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.nodes[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _step2$value = _slicedToArray(_step2.value, 2),
              id = _step2$value[0],
              update = _step2$value[1];

          cov_iirqyzvpw.s[40]++;
          update('active', id === active);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
            _iterator2["return"]();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }, {
    key: "handleNodeClick",
    value: function handleNodeClick(node, id) {
      var _this2 = this;

      cov_iirqyzvpw.f[8]++;

      var _ref3 = (cov_iirqyzvpw.s[41]++, this.props),
          active = _ref3.active,
          onClick = _ref3.onClick;

      cov_iirqyzvpw.s[42]++;

      if (active === undefined) {
        cov_iirqyzvpw.b[17][0]++;
        cov_iirqyzvpw.s[43]++;
        this.setState({
          active: id
        }, function () {
          cov_iirqyzvpw.f[9]++;
          cov_iirqyzvpw.s[44]++;

          _this2.handleActive(id);
        });
      } else {
        cov_iirqyzvpw.b[17][1]++;
      }

      cov_iirqyzvpw.s[45]++;

      if (onClick) {
        cov_iirqyzvpw.b[18][0]++;
        cov_iirqyzvpw.s[46]++;
        onClick(node, id, this.datum.getPath(id));
      } else {
        cov_iirqyzvpw.b[18][1]++;
      }
    }
  }, {
    key: "handleToggle",
    value: function handleToggle(id) {
      cov_iirqyzvpw.f[10]++;

      var _ref4 = (cov_iirqyzvpw.s[47]++, this.props),
          expanded = _ref4.expanded,
          onExpand = _ref4.onExpand;

      var newExpanded;
      cov_iirqyzvpw.s[48]++;

      if ((cov_iirqyzvpw.b[20][0]++, !expanded) && (cov_iirqyzvpw.b[20][1]++, onExpand)) {
        cov_iirqyzvpw.b[19][0]++;
        cov_iirqyzvpw.s[49]++;
        onExpand([id]);
        cov_iirqyzvpw.s[50]++;
        return;
      } else {
        cov_iirqyzvpw.b[19][1]++;
      }

      var expandedArr = (cov_iirqyzvpw.s[51]++, expanded);
      cov_iirqyzvpw.s[52]++;

      if (expandedArr.indexOf(id) >= 0) {
        cov_iirqyzvpw.b[21][0]++;
        cov_iirqyzvpw.s[53]++;
        newExpanded = expandedArr.filter(function (e) {
          cov_iirqyzvpw.f[11]++;
          cov_iirqyzvpw.s[54]++;
          return e !== id;
        });
      } else {
        cov_iirqyzvpw.b[21][1]++;
        cov_iirqyzvpw.s[55]++;
        newExpanded = [].concat(_toConsumableArray(expandedArr), [id]);
      }

      cov_iirqyzvpw.s[56]++;

      if (onExpand) {
        cov_iirqyzvpw.b[22][0]++;
        cov_iirqyzvpw.s[57]++;
        onExpand(newExpanded);
      } else {
        cov_iirqyzvpw.b[22][1]++;
      }
    }
  }, {
    key: "handleDrop",
    value: function handleDrop(id, targetId, position) {
      var _this3 = this;

      cov_iirqyzvpw.f[12]++;

      var _ref5 = (cov_iirqyzvpw.s[58]++, this.props),
          childrenKey = _ref5.childrenKey;

      var current = (cov_iirqyzvpw.s[59]++, this.datum.getPath(id));
      var target = (cov_iirqyzvpw.s[60]++, this.datum.getPath(targetId));
      cov_iirqyzvpw.s[61]++;

      if ((cov_iirqyzvpw.b[24][0]++, !current) || (cov_iirqyzvpw.b[24][1]++, !target)) {
        cov_iirqyzvpw.b[23][0]++;
        cov_iirqyzvpw.s[62]++;
        return;
      } else {
        cov_iirqyzvpw.b[23][1]++;
      }

      var data = (cov_iirqyzvpw.s[63]++, immer(this.props.data, function (draft) {
        cov_iirqyzvpw.f[13]++;
        var node = (cov_iirqyzvpw.s[64]++, draft);
        var temp;
        cov_iirqyzvpw.s[65]++;

        var removeNode = function removeNode() {
          cov_iirqyzvpw.f[14]++;
        };

        var offset = (cov_iirqyzvpw.s[66]++, 0);
        cov_iirqyzvpw.s[67]++;
        current.indexPath.forEach(function (p, i) {
          cov_iirqyzvpw.f[15]++;
          cov_iirqyzvpw.s[68]++;

          if (i < current.indexPath.length - 1) {
            cov_iirqyzvpw.b[25][0]++;
            cov_iirqyzvpw.s[69]++;
            node = node[p][childrenKey];
          } else {
            cov_iirqyzvpw.b[25][1]++;
            cov_iirqyzvpw.s[70]++;
            temp = node;
            cov_iirqyzvpw.s[71]++;

            removeNode = function removeNode() {
              cov_iirqyzvpw.f[16]++;
              cov_iirqyzvpw.s[72]++;
              return temp.splice(p, 1)[0];
            };

            cov_iirqyzvpw.s[73]++;
            node = node[p];
          }
        });
        var tnode = (cov_iirqyzvpw.s[74]++, draft);
        cov_iirqyzvpw.s[75]++;
        target.indexPath.forEach(function (p, i) {
          cov_iirqyzvpw.f[17]++;
          cov_iirqyzvpw.s[76]++;

          if (i < target.indexPath.length - 1) {
            cov_iirqyzvpw.b[26][0]++;
            cov_iirqyzvpw.s[77]++;
            tnode = tnode[p][childrenKey];
          } else {
            cov_iirqyzvpw.b[26][1]++;
            cov_iirqyzvpw.s[78]++;

            if (tnode === temp) {
              cov_iirqyzvpw.b[27][0]++;
              cov_iirqyzvpw.s[79]++;
              // same parent
              removeNode();
              cov_iirqyzvpw.s[80]++;

              if (current.index <= target.index) {
                cov_iirqyzvpw.b[28][0]++;
                cov_iirqyzvpw.s[81]++;
                offset = -1;
              } else {
                cov_iirqyzvpw.b[28][1]++;
              }

              cov_iirqyzvpw.s[82]++;

              removeNode = function removeNode() {
                cov_iirqyzvpw.f[18]++;
              };
            } else {
              cov_iirqyzvpw.b[27][1]++;
            }
          }
        });
        cov_iirqyzvpw.s[83]++;

        if (position === -1) {
          cov_iirqyzvpw.b[29][0]++;
          cov_iirqyzvpw.s[84]++;
          tnode = tnode[target.index + offset];
          cov_iirqyzvpw.s[85]++;

          if (!Array.isArray(tnode[childrenKey])) {
            cov_iirqyzvpw.b[30][0]++;
            cov_iirqyzvpw.s[86]++;
            tnode[childrenKey] = [];
          } else {
            cov_iirqyzvpw.b[30][1]++;
          }

          cov_iirqyzvpw.s[87]++;
          tnode[childrenKey].push(node);
          cov_iirqyzvpw.s[88]++;
          position = tnode[childrenKey].length - 1;
          var update = (cov_iirqyzvpw.s[89]++, _this3.nodes.get(targetId));
          cov_iirqyzvpw.s[90]++;

          if (update) {
            cov_iirqyzvpw.b[31][0]++;
            cov_iirqyzvpw.s[91]++;
            update('expanded', true);
          } else {
            cov_iirqyzvpw.b[31][1]++;
          }
        } else {
          cov_iirqyzvpw.b[29][1]++;
          cov_iirqyzvpw.s[92]++;
          tnode.splice(position + offset, 0, node);
          cov_iirqyzvpw.s[93]++;
          targetId = target.path[target.path.length - 1];
        }

        cov_iirqyzvpw.s[94]++;
        removeNode();
      }));
      cov_iirqyzvpw.s[95]++;

      if (this.props.onDrop) {
        cov_iirqyzvpw.b[32][0]++;
        cov_iirqyzvpw.s[96]++;
        this.props.onDrop(data, id, targetId, position);
      } else {
        cov_iirqyzvpw.b[32][1]++;
      }
    }
  }, {
    key: "handleProps",
    value: function handleProps(key) {
      cov_iirqyzvpw.f[19]++;
      cov_iirqyzvpw.s[97]++;
      return this.props[key];
    }
  }, {
    key: "render",
    value: function render() {
      cov_iirqyzvpw.f[20]++;

      var _ref6 = (cov_iirqyzvpw.s[98]++, this.props),
          className = _ref6.className,
          style = _ref6.style,
          data = _ref6.data,
          disabled = _ref6.disabled,
          line = _ref6.line,
          keygen = _ref6.keygen,
          onExpand = _ref6.onExpand,
          onChange = _ref6.onChange,
          renderItem = _ref6.renderItem,
          _ref6$mode = _ref6.mode,
          mode = _ref6$mode === void 0 ? (cov_iirqyzvpw.b[33][0]++, DefaultProps.mode) : _ref6$mode,
          onDrop = _ref6.onDrop,
          loader = _ref6.loader,
          parentClickExpand = _ref6.parentClickExpand,
          childrenKey = _ref6.childrenKey,
          expandIcons = _ref6.expandIcons,
          _ref6$dragImageStyle = _ref6.dragImageStyle,
          dragImageStyle = _ref6$dragImageStyle === void 0 ? (cov_iirqyzvpw.b[34][0]++, DefaultProps.dragImageStyle) : _ref6$dragImageStyle,
          dragImageSelector = _ref6.dragImageSelector,
          childrenClass = _ref6.childrenClass,
          leafClass = _ref6.leafClass,
          dragHoverExpand = _ref6.dragHoverExpand,
          doubleClickExpand = _ref6.doubleClickExpand,
          iconClass = _ref6.iconClass,
          nodeClass = _ref6.nodeClass,
          dragSibling = _ref6.dragSibling;

      var onToggle = (cov_iirqyzvpw.s[99]++, onExpand ? (cov_iirqyzvpw.b[35][0]++, this.handleToggle) : (cov_iirqyzvpw.b[35][1]++, undefined));
      cov_iirqyzvpw.s[100]++;
      return (
        /*#__PURE__*/
        React.createElement(Root, {
          className: className,
          data: data,
          datum: this.datum,
          disabled: (cov_iirqyzvpw.b[36][0]++, typeof disabled !== 'function') && (cov_iirqyzvpw.b[36][1]++, !!disabled),
          bindNode: this.bindNode,
          keygen: keygen,
          line: line,
          loader: loader,
          mode: mode,
          unbindNode: this.unbindNode,
          onChange: onChange,
          onDrop: (cov_iirqyzvpw.b[37][0]++, onDrop) && (cov_iirqyzvpw.b[37][1]++, this.handleDrop),
          onToggle: onToggle,
          onNodeClick: this.handleNodeClick,
          renderItem: renderItem,
          style: style,
          parentClickExpand: parentClickExpand,
          childrenKey: childrenKey,
          expandIcons: expandIcons,
          dragImageStyle: dragImageStyle,
          dragImageSelector: typeof dragImageSelector === 'function' ? (cov_iirqyzvpw.b[38][0]++, dragImageSelector) : (cov_iirqyzvpw.b[38][1]++, this.handleDragImageSelector),
          childrenClass: typeof childrenClass === 'function' ? (cov_iirqyzvpw.b[39][0]++, childrenClass) : (cov_iirqyzvpw.b[39][1]++, this.handleClidrenClass),
          leafClass: typeof leafClass === 'function' ? (cov_iirqyzvpw.b[40][0]++, leafClass) : (cov_iirqyzvpw.b[40][1]++, this.handleLeafClass),
          dragHoverExpand: dragHoverExpand,
          doubleClickExpand: doubleClickExpand,
          iconClass: iconClass,
          nodeClass: nodeClass,
          dragSibling: dragSibling,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 242,
            columnNumber: 7
          }
        })
      );
    }
  }]);

  return Tree;
}(PureComponent);

Tree.defaultProps = DefaultProps;
export default Tree;